import { render } from "./BarraAnimada.vue?vue&type=template&id=724932e3&scoped=true"
import script from "./BarraAnimada.vue?vue&type=script&lang=js"
export * from "./BarraAnimada.vue?vue&type=script&lang=js"

import "./BarraAnimada.vue?vue&type=style&index=0&id=724932e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724932e3"]])

export default __exports__